import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import {
  passwordDefineReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./PasswordDefine.store";
import { history } from "../../../modules/history.js";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import PasswordDefine from "../../library/PasswordDefine/PasswordDefine";
import { modalType } from "../../../modules/constants";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const SmartPasswordDefine = (props) => {
  const {
    verifyToken,
    setOpenAuthModal,
    showPwRecovery,
    closeModalGoHome,
    isTokenValid,
    submittedChange,
    passwordToken,
    change,
    setPassword,
    accountUsername,
    setModalTitle,
    resetSubmittedChangeState,
    errorMessage,
    resetErrorMessage,
    resetState,
  } = props;

  const { t } = useTranslation();

  const token = props.match?.params.token;
  const email = props.match?.params.email;

  const openModalReset = useCallback(() => {
    setOpenAuthModal(
      modalType.changePassword,
      t("appText.changePassword.title")
    );
  }, [setOpenAuthModal, t]);

  const checkToken = useCallback(() => {
    if (token) {
      verifyToken(token);
    }
  }, [verifyToken, token]);

  const goHome = () => {
    closeModalGoHome();
  };

  const showLoginModal = (e) => {
    e?.preventDefault();
    resetSubmittedChangeState();
    history.push("/home");
    setOpenAuthModal(modalType.login, t("appText.login"));
  };

  useEffect(() => {
    openModalReset();
    if (showPwRecovery) checkToken();
  }, [openModalReset, checkToken]);

  useEffect(() => {
    return () => {
      resetState();
    };
  }, [resetState]);

  return showPwRecovery ? (
    <PasswordDefine
      isTokenValid={isTokenValid}
      submittedChange={submittedChange}
      passwordToken={passwordToken}
      change={change}
      setPassword={setPassword}
      accountUsername={accountUsername}
      setModalTitle={setModalTitle}
      token={token}
      email={email}
      goHome={goHome}
      showLoginModal={showLoginModal}
      errorMessage={errorMessage}
      resetErrorMessage={resetErrorMessage}
    />
  ) : null;
};

export default dynamic(
  "passwordDefineReducer",
  subspaced({
    mapExtraState: (state) => ({
      recoveryReducer: state.recoveryReducer,
      loginReducer: state.loginReducer,
    }),
  }),
  attachReducer(passwordDefineReducer)
)(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(SmartPasswordDefine))
);
